import axios from 'axios'
import config from '@/config'
import store from '../store'
import router from '../router'
import { toReauth } from '@/utils'

let Repository = axios.create({
    baseURL : config.CONNECTOR_APP_RAILS_BASE_URL + '/v1',
    headers:{
        "Accept": "application/json",
        'Content-Type': 'application/json'
    },
    withCredentials: true,
})

Repository.interceptors.request.use(
  (config) => {
    config.headers["http-auth"] = store.getters['auth/connectorAppData'].access_token;
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
); 

Repository.interceptors.response.use((response) => {
    return response
  }, (error) => {
    if (error.response || error.request) {
      const data = error.response || error.request
      switch (data.status) {
        case 401 :
          toReauth()
          break

        case 403 :
          router.push('/access-denied')
          break
        case 422 :
          if(data && data.data && (typeof (data.data.errors) === 'object')){
            let errors = ''
            let subErrors = ''
             /**
              * Here we are iterrating through errors object and appending all the errors in a string
              * If there are more than one errors then there is a numbering system otherwise not
              * If the base error comes then we don't show it other wise we show the key name of the error
             */
            Object.entries(data.data.errors).map((element,index) => {
              subErrors = ''
              element[1].map((error) => {
                subErrors += error + ' '
              })
              /**
               * Make error First letter capital and replace _ to space!
               * Example:
               * 1. { "name" : ["is already used"] } - Name is already used
               * 2. { "base" : ["invalid data"] } - Invalid data
               * 3. { "phone_number": ["is invalid"]} - Phone number is invalid
               */ 
              errors += `${(Object.entries(data.data.errors).length >1 ? index+1+')' : '')} 
              ${(element[0] !== 'base' ? element[0][0].toUpperCase() + element[0].substring(1).replace(/_/g, ' ') + ' ' : '')}
              ${(element[0] !== 'base' ? subErrors : subErrors[0].toUpperCase() + subErrors.substring(1))}<br/>`
            })
            store.commit('ui/snackbar', { message: errors, type: 'error' })
          } else if(data && data.data && data.data.errors){
            store.commit('ui/snackbar', {
            message: data.data.errors,
            type: 'error',
          }) 
          }
        break
        case 460 :
          if(store.getters['auth/isFreeTrial'] && router.currentRoute.name !== 'Dashboard'){
            let titleName = router.currentRoute.name === 'No_Access' ? router.currentRoute.query.titleName : router.currentRoute.name;
            router.push({ path: '/error-460', query: {titleName} })
          }
        break
        case 500 :
          /**
           * Reason to exclude the [GET] method error code 500 :
           * On Dashboard/In Application... API in [GET] request getting the error (!!To show the error on dashboard something bad!!)
           * Will remove the condition when everything finalizes from APIs end!
           */
          if (data.config.method !== 'get') {
            store.commit('ui/snackbar', { message: 'Something went wrong. Please try again.', type: 'error' })
          }
        break
      }
    }
    if ((error.response && error.response.status === 401) ||
      (error.request && error.request.status === 401)
    ) {

    } else {
      if (error.response) {
        const status = error.response.status
        const data = {
          message: status >= 500 ? error.response.statusText : error.response.data,
          type: 'error',
        }
        const env = document.location.hostname.replace('.maropost.com', '')
      // if(env == 'sandbox' || status < 500){
      //   store.commit('ui/snackbar',data)
      // }
      } else if (error.request) {

      }
    }

    return Promise.reject(error)
  })
export default Repository